import { useMemo, useState } from "react";
import { styled } from "@mui/material/styles";
import { Container, Divider, Grid, Tab, Tabs } from "@mui/material";
import RenderAnimation from "../../util/ui/renderAnimation";
import CardDistribuicao from "./distribuicao";
import CardProventos from "./proventos";
import CardProdutos from "./produtos";
import CardRentabilidadeDiaria from "./rentabilidadeDiaria";
import CardRentabilidadeMensal from "./rentabilidadeMensal";
import { TabContext, TabPanel } from "@mui/lab";
import {
  IconChartArea,
  IconChartDonut,
  IconGraph,
} from "@tabler/icons-react";

const PREFIX = "index";

const classes = {
  comece: `${PREFIX}-comece`,
  container: `${PREFIX}-container`,
  cardSpacing: `${PREFIX}-cardSpacing`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`& .${classes.comece}`]: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },

  // Gutter do sistema: 32px no desktop, 24px no mobile (DESIGN.md → Spacing).
  [`&.${classes.container}`]: {
    padding: theme.spacing(4, 4),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2, 3),
    },
  },

  [`& .${classes.cardSpacing}`]: { padding: theme.spacing(1) },
}));

export default function Analises() {
  const cardProventos = useMemo(() => <CardProventos />, []);
  const cardDistribuicao = useMemo(() => <CardDistribuicao />, []);
  const cardProdutos = useMemo(() => <CardProdutos />, []);
  const cardRentabilidadeDiaria = useMemo(
    () => <CardRentabilidadeDiaria />,
    []
  );
  const cardRentabilidadeMensal = useMemo(
    () => <CardRentabilidadeMensal />,
    []
  );

  const [tab, setTab] = useState("proventos");

  return (
    <StyledContainer maxWidth="lg" className={classes.container}>
      <TabContext value={tab}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          // Aba ativa em accent-ink (tinta), nunca em accent sólido: sobre
          // superfície escura o indigo puro reprova em contraste.
          sx={(theme) => ({
            minHeight: 48,
            "& .MuiTab-root": {
              minHeight: 48,
              color: theme.palette.text.secondary,
            },
            "& .MuiTab-root.Mui-selected": { color: theme.palette.accentInk },
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.accentInk,
              height: 2,
            },
          })}
        >
          <Tab
            value="proventos"
            label="Proventos"
            iconPosition="start"
            icon={<IconChartArea />}
          />
          <Tab
            value="distribuição"
            label="Distribuição"
            iconPosition="start"
            icon={<IconChartDonut />}
          />
          <Tab
            value="rentabilidade"
            label="Rentabilidade"
            iconPosition="start"
            icon={<IconGraph />}
          />
        </Tabs>
        <Divider />
        <TabPanel value="rentabilidade">
          <Grid container alignItems="flex-start" alignContent="stretch">
            <Grid item xs={12} className={classes.cardSpacing}>
              <RenderAnimation
                key="Rentabilidade por dia"
                delay={1 * 300}
                render={() => cardRentabilidadeDiaria}
              />
            </Grid>
            <Grid item xs={12} className={classes.cardSpacing}>
              <RenderAnimation
                key="Rentabilidade por mês"
                delay={2 * 300}
                render={() => cardRentabilidadeMensal}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value="proventos">
          <Grid container alignItems="flex-start" alignContent="stretch">
            <Grid item xs={12} className={classes.cardSpacing}>
              <RenderAnimation
                key="Proventos"
                delay={1 * 300}
                render={() => cardProventos}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value="distribuição">
          <Grid container alignItems="flex-start" alignContent="stretch">
            <Grid item xs={12} md={8} className={classes.cardSpacing}>
              <RenderAnimation
                key="Produtos"
                delay={2 * 300}
                render={() => cardProdutos}
              />
            </Grid>
            <Grid item xs={12} md={4} className={classes.cardSpacing}>
              <RenderAnimation
                key="Distribuição"
                delay={3 * 300}
                render={() => cardDistribuicao}
              />
            </Grid>
          </Grid>
        </TabPanel>
      </TabContext>
    </StyledContainer>
  );
}
